export default __webpack_public_path__ + "static/media/wifi.98398a1e.png";